import { createFileRoute, redirect } from "@tanstack/react-router";

import { requestedHref } from "@/api/requested-href";
import { stripLegacyBasepath } from "@/lib/route-paths";

// **Modsy's basepath** — `/digitalops/<rest>` → `/<rest>` (ADR-0019 decision 5;
// research §5.1). Modsy served every page under `BrowserRouter
// basename='/digitalops'` (`timmy/.env.production:4`), so every link it handed
// out carries the prefix: share links (`/digitalops/public-spec/…`), the public
// product page's (`/digitalops/products/:id`), and every authed bookmark. Atlas
// serves at the root; once the cutover host routes modsy's host here with path
// and query intact, this lands each of them on its page.
//
// **Every path, not only the public ones**: the target applies its own gate, so
// an authed bookmark still meets its sign-in. Public by necessity — a share
// link's holder has no session — and harmless by construction: it renders
// nothing, and the target is always a path on this origin (`stripLegacyBasepath`
// collapses any `//`, so it is never an open redirect). The query rides
// verbatim, the token unencoded and unaltered, and the hash with it. `replace`,
// so Back never returns to the prefixed URL.
export const Route = createFileRoute("/digitalops/$")({
  beforeLoad: ({ location }) => {
    // The visitor's own spelling of the URL, never the router's re-serialised
    // one: the query must reach the target byte for byte.
    const href = stripLegacyBasepath(requestedHref(location.href), "/digitalops");
    throw redirect({ href, replace: true });
  },
});
